import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import CustomerDashboard from "@/pages/CustomerDashboard";
import RemovalistDashboard from "@/pages/RemovalistDashboard";
import PostJob from "@/pages/PostJob";
import Movers from "@/pages/Movers";
import ForRemovalists from "@/pages/ForRemovalists";
import JobDetail from "@/pages/JobDetail";
import RemovalistProfile from "@/pages/RemovalistProfile";
import RemovalistPublicProfile from "@/pages/RemovalistPublicProfile";
import AdminDashboard from "@/pages/AdminDashboard";
import InventoryTool from "@/pages/InventoryTool";
import ClaimListing from "@/pages/ClaimListing";
import Unsubscribe from "@/pages/Unsubscribe";

function Dashboard() {
  const { user } = useAuth();
  if (user && user.role === "admin") return <Navigate to="/admin" replace />;
  if (user && user.role === "removalist") return <RemovalistDashboard />;
  return <CustomerDashboard />;
}

function AppRoutes() {
  const location = useLocation();
  // Handle Emergent Google OAuth callback before any route/auth check runs.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/movers" element={<Movers />} />
      <Route path="/for-removalists" element={<ForRemovalists />} />
      <Route path="/inventory" element={<InventoryTool />} />
      <Route path="/claim/:token" element={<ClaimListing />} />
      <Route path="/unsubscribe/:token" element={<Unsubscribe />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
      <Route path="/post-job" element={<ProtectedRoute role="customer"><PostJob /></ProtectedRoute>} />
      <Route path="/jobs/:id" element={<ProtectedRoute><JobDetail /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute role="removalist"><RemovalistProfile /></ProtectedRoute>} />
      <Route path="/removalists/:id" element={<RemovalistPublicProfile />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
